import { Bounds } from '@ardoq/graph';
import type { BlocksViewNode } from '../../types';
import {
  BLOCKS_VIEW_NODE_PAD,
  BLOCKS_VIEW_URL_ICON_SIZE,
  INVALID_RECTANGLE_SIDES,
} from '../../consts';
import {
  collapsedGroupHeaderBottom,
  openGroupHeaderTopTextBaseline,
} from '../util';

const leafUrlIconRect = ([, top, right]: Bounds): Bounds => [
  right - BLOCKS_VIEW_NODE_PAD - BLOCKS_VIEW_URL_ICON_SIZE,
  top + BLOCKS_VIEW_NODE_PAD,
  right - BLOCKS_VIEW_NODE_PAD,
  top + BLOCKS_VIEW_NODE_PAD + BLOCKS_VIEW_URL_ICON_SIZE,
];
const openGroupUrlIconRect = (node: BlocksViewNode, cell: Bounds): Bounds => {
  const {
    displayLabel: [mainLabel],
  } = node;
  const isSingleLineHeader = !mainLabel || mainLabel.length <= 1;
  if (isSingleLineHeader) {
    const [, , right] = cell;
    const centerY = openGroupHeaderTopTextBaseline(node, cell);
    return [
      right - BLOCKS_VIEW_NODE_PAD - BLOCKS_VIEW_URL_ICON_SIZE,
      centerY - BLOCKS_VIEW_URL_ICON_SIZE / 2,
      right - BLOCKS_VIEW_NODE_PAD,
      centerY + BLOCKS_VIEW_URL_ICON_SIZE / 2,
    ];
  }
  return leafUrlIconRect(cell);
};
const collapsedComponentGroupUrlIconRect = (cell: Bounds): Bounds => {
  const [, , right] = cell;
  const headerBottom = collapsedGroupHeaderBottom(cell);
  return [
    right - BLOCKS_VIEW_NODE_PAD - BLOCKS_VIEW_URL_ICON_SIZE,
    headerBottom + BLOCKS_VIEW_NODE_PAD,
    right - BLOCKS_VIEW_NODE_PAD,
    headerBottom + BLOCKS_VIEW_NODE_PAD + BLOCKS_VIEW_URL_ICON_SIZE,
  ];
};
const urlIconRect = (node: BlocksViewNode, cell = node.cell): Bounds => {
  if (!cell) {
    return INVALID_RECTANGLE_SIDES;
  }
  const { children, open } = node;
  const isGroup = children?.length;
  if (isGroup) {
    if (open) {
      return openGroupUrlIconRect(node, cell);
    }
    return collapsedComponentGroupUrlIconRect(cell);
  }
  return leafUrlIconRect(cell);
};

export { urlIconRect };
